import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import Layout from './layouts/Layout';
import { Provider } from 'react-redux';
import store from './store';
import '../src/assets/scss/user.scss';
import * as Sentry from '@sentry/react';
import ChatProvider from 'components/pages/elvis-history/ChatProvider';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DNS_KEY,
  integrations: [],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enabled:
    process.env.REACT_APP_NODE_ENV !== 'development' &&
    process.env.REACT_APP_NODE_ENV !== 'staging'
});

const App = () => {
  return (
    <Provider store={store}>
      <Router basename={process.env.PUBLIC_URL}>
        <ChatProvider>
          <Layout />
        </ChatProvider>
      </Router>
    </Provider>
  );
};

export default App;
